export default "__VITE_ASSET__DnPz2C1x__"